import Request from "./Request";

export default {
  sendData(data) {
    const url = "data/import";
    return Request.post_data(url, data);
  },
  
  sendInnoDotData(data) {
    const url = "innodot/import";
    return Request.post_data(url, data);
  },
};
